export const PDF_MIME: string = 'application/pdf';
export const DOC_MIME: string = 'application/msword';
export const DOCX_MIME: string = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';